import type { HeadlineResponsePersonBaseRelatedPagedData } from '@on3/api';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { PlayerNewsItem } from './PlayerNewsItem';
import styles from './PlayerNewsModule.module.scss';

interface IPlayerNewsProps {
  recruitsArticles: HeadlineResponsePersonBaseRelatedPagedData;
  recruitmentKey?: number | null;
}

export const PlayerNewsModule = ({
  recruitsArticles,
  recruitmentKey,
}: IPlayerNewsProps) => {
  const { list = [], relatedModel, pagination } = recruitsArticles;
  const router = useRouter();
  const viewAllRoute = `/rivals/${router.query.id}/recruiting/${recruitmentKey}/news/`;
  const viewAllrecruitArticles = (pagination?.pageCount ?? 0) > 1;

  return (
    <section className={styles.block}>
      <h2>{`${relatedModel?.lastName || ''} News`}</h2>
      <div className={styles.articles}>
        {list.length > 0 ? (
          <>
            {list.map((item) => (
              <PlayerNewsItem {...item} key={item.key} />
            ))}
          </>
        ) : (
          <p className={styles.noNews}>No news</p>
        )}
      </div>
      {viewAllrecruitArticles && (
        <footer className={styles.footer}>
          <Link href={viewAllRoute}>View All</Link>
        </footer>
      )}
    </section>
  );
};
